import React from 'react'
import { useTranslation } from 'react-i18next'
import { MwSpinnerIcon } from './MwLoadingOverlay'

// Page loading state: the same spinner and "جاري التحميل..." text as the invoices list loader
// (MwLoadingOverlay), so every page (invoice, quote, credit note, settings...) loads the same way.
const MwSpinner = ({hightScreen=true, label, compact=false}) => {
    const [t] = useTranslation('contracts');
    const text = label ?? t('common.loading', { defaultValue: 'جاري التحميل...' });
    return (
        <div role="status" aria-live="polite" className={`flex flex-col gap-3 justify-center text-center items-center w-full ${hightScreen ? 'h-screen' : 'h-full py-10'}`} >
            <MwSpinnerIcon size={compact ? 32 : 56} />
            {!compact && <span className="text-sm font-bold text-indigo-600">{text}</span>}
        </div>
    )
}

export default MwSpinner
